import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import type { PosthogStoreState } from './types'

export const usePosthogStore = create<PosthogStoreState>()(
  devtools(
    set => ({
      ready: false,
      error: false,
      setLoading: () =>
        set(
          state =>
            state.ready || state.error ? { ready: false, error: false } : state,
          false,
          'posthog/loading',
        ),
      setReady: (error = false) =>
        set(
          state =>
            state.ready && state.error === error
              ? state
              : { ready: true, error },
          false,
          'posthog/ready',
        ),
      reset: () =>
        set(
          state =>
            state.ready || state.error ? { ready: false, error: false } : state,
          false,
          'posthog/reset',
        ),
    }),
    {
      name: 'Posthog Store',
      enabled: process.env.NODE_ENV !== 'production',
    },
  ),
)

export const usePosthogReady = () => usePosthogStore(state => state.ready)
export const usePosthogError = () => usePosthogStore(state => state.error)
